import React from 'react';
import { useAuth } from '../auth/Auth';
import PartnerChat from './PartnerChat';
import DependentChat from './DependentChat';

const AgoraChat = (props) => {
  const { dependent, partner, school } = useAuth();
  return (
    partner || school ?
      props?.challenge?.agora_group_id ?
        <PartnerChat challenge={props.challenge} />
        : ""
      : <DependentChat challenge={props.challenge} />
  )
}

export default AgoraChat;
